import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';

const generateImgixUrl = (url) => {
  let res = url.replace(
    'https://front.travpromobile.com/',
    'https://imgtravpromobile.imgix.net/'
  );
  res = res.replace(
    'https://s3.amazonaws.com/developertool/',
    'https://imgtravpromobile.imgix.net/'
  );
  const returnValue = `${res}?fit=clip&w=200&h=auto`;
  return returnValue;
};

const ContactViewCard = ({
  name,
  description,
  telephone,
  title,
  mails,
  imageUrl,
}) => (
  <div className="contactView__Content">
    <img
      className="headshot"
      src={generateImgixUrl(imageUrl)}
      alt={`${name} - ${description}`}
    />
    <h1>{name}</h1>

    <h3 className="title">{title}</h3>
    {telephone && <a href={`tel:${telephone.trim()}`}>
      <FontAwesomeIcon icon={['fas', 'phone']} />+{telephone}
    </a>}
    <a href={`mailto:${mails}`}>
      <FontAwesomeIcon icon={['fas', 'envelope']} />
      {mails}
    </a>
  </div>
);

export default ContactViewCard;
